<button class="quickview__close custom-close" type="button" appClick (click)="bsModalRef.hide()">
    <app-icon name="cross-20" size="20"></app-icon>
</button>

<div class="content">

    <div class="body-content">
        <div *ngIf="loadingComposizioni || loadingAttributi" class="text-center">
            <i class="fa fa-3x fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
        <div class="levels" *ngIf="articolo.composizione_articolo && articolo.composizione_articolo.length">
            <div class="level" *ngFor="let level of levels">
                <h5 class="no-margin-bottom">{{level.descrizione}}</h5>
                <p *ngIf="isInteractiveBoxView()" class="no-margin-bottom" style="color: gray;">
                    <small *ngIf="level.minimo_articoli == level.limite_articoli">Scegli {{level.minimo_articoli}} articol{{level.minimo_articoli == 1 ? 'o': 'i'}}</small>
                    <small *ngIf="level.minimo_articoli != level.limite_articoli">Scegli da {{level.minimo_articoli}} a {{level.limite_articoli}} articoli</small>
                </p>
    
                <p *ngIf="isInteractiveBoxView()" class="no-margin-bottom" style="color: red;">
                    <small *ngIf="errorsChecked && isLevelHaveQuantityError(level) as err">
                        {{err}}
                    </small>
                </p>
                <div class="items-box mb-3" [ngClass]="{'items-disabled': isInteractiveBoxView() && !canAddToLevel(level.codice_livello), 'items-readonly': readOnlyBoxView}">
                    <div class="item" [ngClass]="{'item-selected': item.qta_selezionata, 'item-not-selected': !item.qta_selezionata}" *ngFor="let item of level.items"
                        (click)="toggleItem(item)">
                        <div class="description" style="display: flex; align-items: center;">
                            <img class="mr-2" *ngIf="item.articolo_componente?.cdn_url" [src]="item.articolo_componente?.cdn_url" width="50" height="50">
                            <div>
                                {{item.articolo_componente?.descart}}
                                <span *ngIf="showPrices()" class="ml-1 mr-1 prezzo">+{{ (isB2B() ? item.prezzo_netto : item.prezzo_lordo) | currencyFormat}}</span>
                            </div>
                        </div>
                        <div *ngIf="isInteractiveBoxView()" class="end">
                            <div class="quantity" [attr.hidden]="!item.qta_selezionata && !isAvailable(item) ? true : null">
                                <span *ngIf="item.must_have" class="badge badge-warning mr-1">Obbligatorio</span>
                                <div [ngClass]="{'disabled': !canRemove(item)}" *ngIf="item.qta_selezionata"
                                    (click)="toggleItem(item, -1, $event)" class="customButton">&minus;</div>
                                <div *ngIf="item.qta_selezionata" class="quantity__value">{{item.qta_selezionata}}</div>
                                <div [ngClass]="{'disabled': !canAdd(item)}" class="customButton"
                                    (click)="toggleItem(item, 1, $event)">+</div>
                            </div>
                            <div *ngIf="!isAvailable(item) as notAvailable" style="position: relative; text-align: right;"
                                [ngStyle]="{'height': item.qta_selezionata >= 1 ? 0 : 'unset'}">
                                <small class="text-danger">Non disponibile</small>
                            </div>
                        </div>
                        <div *ngIf="readOnlyBoxView" class="readonly-chip">
                            <span class="badge badge-light">{{ item.qta }}x</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="levels" *ngIf="isInteractiveBoxView() && articolo.attributi && articolo.attributi.length">
            <div class="level">
                <h5 class="no-margin-bottom">Opzionale</h5>
                <div class="items-box mb-3">
                    <div *ngFor="let attribute of articolo.attributi" (click)="toggleAttribute(attribute)"
                        class="item" [ngClass]="{'item-selected': attribute.selected}">
                        <div class="description">
                            {{attribute.descrizione}}
                            <span *ngIf="attribute.prezzo && attribute.tipo_battuta != 2"
                            class="ml-1 mr-1 prezzo">+{{ attribute.prezzo | currencyFormat}}</span>
                        </div>
                        <div class="quantity" style="gap: 7px">
                            <small *ngIf="!isAttributeAvailable(attribute)" class="text-danger">Non disponibile</small>
                            <div *ngIf="attribute.selected" class="customButton checkmark">L</div>
                            <div *ngIf="!attribute.selected && isAttributeAvailable(attribute)" class="customButton">+</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="product-details">
        <div class="product-details__image--wrapper">
            <img class="product-details__image" [src]="articolo.cdn_url">
        </div>

        <h1 class="product-details__name">{{articolo.descart}}</h1>
        <div class="product-details__price">
            {{total + priceArticolo.priceOfAttributeSelected(articolo) | currencyFormat}}
        </div>
        <div class="product-details__description">{{articolo.descrizione_estesa}}</div>
        <div *ngIf="readOnlyBoxView" class="read-only-note">
            Scegli un articolo per portata e gusta il nostro menù!
        </div>
        <button *ngIf="isInteractiveBoxView()" class="btn btn-primary btn-lg btn-add d-none d-md-block" style="border-radius: 25px;"
        [attr.disabled]="!canAddToCart() ? true : null" (click)="addToCart()">{{item ? 'Modifica' : 'Aggiungi'}}</button>
    </div>

    <div *ngIf="isInteractiveBoxView()" class="d-md-none btn-add-container">
        <button class="btn btn-primary btn-lg btn-add" style="border-radius: 25px;"
        [attr.disabled]="!canAddToCart() ? true : null" (click)="addToCart()">{{item ? 'Modifica' : 'Aggiungi'}}</button>
    </div>
    
</div>
